module.exports = __webpack_public_path__ + "static/media/icon-event__eta-hover.2d59b5f8.svg";